import { render, staticRenderFns } from "./PublicationInformation.vue?vue&type=template&id=59fa076b"
import script from "./PublicationInformation.vue?vue&type=script&lang=js"
export * from "./PublicationInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports